// SPDX-License-Identifier: AGPL-3.0-or-later

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import {makeAutoObservable, runInAction, when} from 'mobx';

// Micup: the shop row's NEW badge. Discovery names when a product last went on sale; this keeps, per account and
// device, the latest such time the shop was opened after. A first run counts whatever is on sale as seen.
class ShopNewListingState {
	seenListedAt: number | null = null;
	hydrated = false;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void makePersistent(this, 'ShopNewListing', ['seenListedAt']).then(this.markHydrated);
	}

	get hasNew(): boolean {
		if (!this.hydrated) return false;
		const latest = RuntimeConfig.shopLatestListedAt;
		return latest !== null && this.seenListedAt !== null && latest > this.seenListedAt;
	}

	markSeen(): void {
		const latest = RuntimeConfig.shopLatestListedAt;
		if (latest !== null) this.seenListedAt = latest;
	}

	// The stored record can be read before the instance runtime is active; the first run waits for its discovery.
	markHydrated(): void {
		void when(() => RuntimeConfig.getSnapshotOrNull() !== null).then(() =>
			runInAction(() => {
				this.seenListedAt ??= RuntimeConfig.shopLatestListedAt ?? 0;
				this.hydrated = true;
			}),
		);
	}
}

export default new ShopNewListingState();
